<template>
  <div id="sales">
    <TipBox info no-border :title="$t('tips.sales.title')">
      <p v-html="$t('tips.sales.description')"></p>
      <p v-html="$t('tips.sales.description_2')"></p>
    </TipBox>
    <TipBox danger>
      <span v-html="$t('tips.sales.warning')"></span>
    </TipBox>
    <div style="text-align: right">
      <select v-if="$route.query.company" v-model="selected">
        <option value="sale">{{$t('sales.title')}}</option>
        <option value="onHold">{{$t('sales.on_hold')}}</option>
      </select>
    </div>
    <Datatable
      class="datatable"
      ref="datatable"
      :entity="dTableEntity"
      :parameters="datatableParameters"
      :onRowClick="onRowClick"
      :rowActions="[]"
    />
  </div>
</template>

<script>

  import Datatable from "@/components/Datatable.vue";

  export default {

    name: 'sales',
    components: { Datatable },

    data() {
      return {
        datatableParameters: {},
        inventoryId: null,
        selected: 'sale'
      }
    },

    computed: {
      dTableEntity() {
        if (this.$route.query.company) {
          return this.selected === 'onHold' ? 'hold_and_fire' : 'sale_company'
        } else if (this.$route.query.branch) {
          return 'sale_branch'
        }
      }
    },

    mounted() {
      this.$store.state.pageTitleTranslationKey = "sales.title";
      this.$store.state.pageIcon = "/icon/sales.svg";
      this.setDatatableParameters();
    },

    methods: {
      onRowClick(row) {
        this.$router.push(this.$router.buildContext("/sale", {id: row.id}));
      },
      setDatatableParameters() {
        this.datatableParameters.inventory = this.inventoryId;
        let branch = this.$route.query.branch;
        let company = this.$route.query.company;
        if (company) {
          this.datatableParameters.company = company;
        } else if (branch) {
          this.datatableParameters.branch = branch;
        }
      }
    }
  };

</script>
